import request from '@/utils/request'
import { downloadBlob } from '../../utils/helpers'
import uuid from 'uniq-id'

export default {
    getBusinessReports: async({ dispatch, commit }, params) => {
        await request({
            method: 'get',
            url: 'report/business',
            responseType: params.excel ? 'blob' : 'json',
            params: {
                ...Object.select(params, ['fromDate', 'toDate', 'page', 'excel', 'column', 'direction'])
            }
        }).then(res => {
            if (res.data && res.data.reports && res.data.sum) {
                commit('SET_BUSINESS_DATEGROUP_SUM', res.data.sum)
                commit('SET_BUSINESS_DATEGROUP_REPORTS', res.data.reports)
                commit('SET_BUSINESS_DATEGROUP_PAGINATION', {
                    length: res.data.totalPages,
                    page: res.data.page,
                    total: res.data.total
                })
            } else if (res.data && params.excel) {
                downloadBlob(res.data, `Report_${uuid()}.xlsx`)
            }
            commit('SET_BUSINESS_DATEGROUP_LOAD', false)
        })
    },

    getLeaderReports: async({ dispatch, commit }, params) => {
        await request({
            method: 'get',
            url: 'report/leader',
            responseType: params.excel ? 'blob' : 'json',
            params: {
                ...Object.select(params, ['fromDate', 'toDate', 'page', 'excel', 'column', 'direction'])
            }
        }).then(res => {
            if (res.data && res.data.reports && res.data.sum) {
                commit('SET_LEADER_BUSINESSGROUP_SUM', res.data.sum)
                commit('SET_LEADER_BUSINESSGROUP_REPORTS', res.data.reports)
                commit('SET_LEADER_BUSINESSGROUP_PAGINATION', {
                    length: res.data.totalPages,
                    page: res.data.page,
                    total: res.data.total
                })
            } else if (res.data && params.excel) {
                downloadBlob(res.data, `Report_${uuid()}.xlsx`)
            }
            commit('SET_LEADER_BUSINESSGROUP_LOAD', false)
        })
    },

    getAdminLeaderGroupReports: async({ dispatch, commit }, params) => {
        await request({
            method: 'get',
            url: 'report/admin/leader',
            responseType: params.excel ? 'blob' : 'json',
            params: {
                ...Object.select(params, ['fromDate', 'toDate', 'page', 'excel', 'column', 'direction'])
            }
        }).then(res => {
            if (res.data && res.data.reports && res.data.sum) {
                commit('SET_ADMIN_LEADERGROUP_SUM', res.data.sum)
                commit('SET_ADMIN_LEADERGROUP_REPORTS', res.data.reports)
                commit('SET_ADMIN_LEADERGROUP_PAGINATION', {
                    length: res.data.totalPages,
                    page: res.data.page,
                    total: res.data.total
                })
            } else if (res.data && params.excel) {
                downloadBlob(res.data, `Report_${uuid()}.xlsx`)
            }
            commit('SET_ADMIN_LEADERGROUP_LOAD', false)
        })
    },

    getAdminBusinessGroupReports: async({ dispatch, commit }, params) => {
        await request({
            method: 'get',
            url: 'report/leader',
            responseType: params.excel ? 'blob' : 'json',
            params: {
                leaderId: params.leader && params.leader.id || null,
                ...Object.select(params, ['fromDate', 'toDate', 'page', 'excel', 'column', 'direction'])
            }
        }).then(res => {
            if (res.data && res.data.reports && res.data.sum) {
                commit('SET_ADMIN_BUSINESSGROUP_SUM', res.data.sum)
                commit('SET_ADMIN_BUSINESSGROUP_REPORTS', res.data.reports)
                commit('SET_ADMIN_BUSINESSGROUP_PAGINATION', {
                    length: res.data.totalPages,
                    page: res.data.page,
                    total: res.data.total
                })
            } else if (res.data && params.excel) {
                downloadBlob(res.data, `Report_${uuid()}.xlsx`)
            }
            commit('SET_ADMIN_BUSINESSGROUP_LOAD', false)
        })
    },

    getAdminDayGroupReports: async({ dispatch, commit }, params) => {
        await request({
            method: 'get',
            url: '/report/admin/withdraw',
            responseType: params.excel ? 'blob' : 'json',
            params: {
                leaderId: params.leader && params.leader.id || null,
                ...Object.select(params, ['fromDate', 'toDate', 'page', 'excel', 'column', 'direction'])
            }
        }).then(res => {
            if (res.data && res.data.reports && res.data.sum) {
                commit('SET_ADMIN_DAYGROUP_SUM', res.data.sum)
                commit('SET_ADMIN_DAYGROUP_REPORTS', res.data.reports)
                commit('SET_ADMIN_DAYGROUP_PAGINATION', {
                    length: res.data.totalPages,
                    page: res.data.page,
                    total: res.data.total
                })
            } else if (res.data && params.excel) {
                downloadBlob(res.data, `Report_${uuid()}.xlsx`)
            }
            commit('SET_ADMIN_DAYGROUP_LOAD', false)
        })
    }
}
